import React from "react";
import { IconProps } from "./IconProps";

const Edit: React.FC<IconProps> = ({
    size = 22,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
            <g clip-path="url(#clip0_5340_22442)">
                <path d="M9.16666 2.50019L5.66666 2.50019C4.26653 2.50019 3.56647 2.50019 3.03169 2.77267C2.56128 3.01236 2.17883 3.39481 1.93915 3.86521C1.66666 4.39999 1.66666 5.10006 1.66666 6.50019L1.66666 13.5002C1.66666 14.9003 1.66666 15.6004 1.93915 16.1352C2.17883 16.6056 2.56128 16.988 3.03169 17.2277C3.56647 17.5002 4.26653 17.5002 5.66666 17.5002H12.6667C14.0668 17.5002 14.7669 17.5002 15.3016 17.2277C15.772 16.988 16.1545 16.6056 16.3942 16.1352C16.6667 15.6004 16.6667 14.9003 16.6667 13.5002V10.0002M6.66664 12.5002H8.06209C8.46975 12.5002 8.67357 12.5002 8.86538 12.4541C9.03544 12.4133 9.19802 12.346 9.34714 12.2546C9.51533 12.1515 9.65946 12.0074 9.94771 11.7191L17.9167 3.75019C18.607 3.05983 18.607 1.94055 17.9167 1.25019C17.2263 0.559834 16.107 0.559833 15.4167 1.25019L7.44769 9.21914C7.15944 9.50739 7.01531 9.65152 6.91224 9.81971C6.82086 9.96884 6.75352 10.1314 6.71269 10.3015C6.66664 10.4933 6.66664 10.6971 6.66664 11.1048L6.66664 12.5002Z" stroke="#F7F9F9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_5340_22442">
                    <rect width={size} height={size} fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Edit;
